module.exports = __webpack_public_path__ + "static/media/nav-expand.87db7309.svg";